import React from 'react'
import AboutBanner from './AboutBanner'
import WhoWeAre from './WhoWeAre'
import OurMission from './OurMission';
import Testimonail from './Testimonail';

const MainAbout = () => {
  return (
    <>
      <AboutBanner />
      <WhoWeAre />
      <OurMission/>
      <Testimonail/>
    </>
  );
}

export default MainAbout